<template>
  <el-card>
    <div slot="header">
      Alapadatok
    </div>
    <el-form
      ref="basicDataForm"
      label-position="top"
      :model="basicData"
      :rules="rules"
    >
      <el-row :gutter="20" v-if="stockTakingReport.id">
        <el-col :span="12">
          <el-form-item
            label="Év"
            prop="year"
          >
            <el-input
              v-model="basicData.year"
              style="width: 100%"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Sorszám"
            prop="number"
          >
            <el-input
              v-model="basicData.number"
              style="width: 100%"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Felelős"
            prop="responsible_user"
          >
            <el-select
              v-model="basicData.responsible_user"
              style="width: 100%;"
              filterable
              value-key="id"
              :disabled="dialogType === 'view'"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Raktár"
            prop="storage"
          >
            <el-select
              v-model="basicData.storage"
              style="width: 100%;"
              filterable
              value-key="id"
              :disabled="dialogType === 'view'"
            >
              <el-option
                v-for="storage in storages"
                :key="storage.id"
                :label="storage.name"
                :value="storage"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Leltározás kezdete"
            prop="start_date"
          >
            <el-date-picker
              v-model="basicData.start_date"
              type="datetime"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd. HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Leltározás befejezése"
            prop="end_date"
          >
            <el-date-picker
              v-model="basicData.end_date"
              type="datetime"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd. HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="{ firstDayOfWeek: 1 }"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Leltárak kiértékelése"
            prop="rate_date"
          >
            <el-date-picker
              v-model="basicData.rate_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Záró jegyzőkönyv határideje"
            prop="close_report_deadline_date"
          >
            <el-date-picker
              v-model="basicData.close_report_deadline_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Eltérések könyvelésének határideje"
            prop="diff_accountant_deadline_date"
          >
            <el-date-picker
              v-model="basicData.diff_accountant_deadline_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Eltérések miatti felelősség megállapítása"
            prop="diff_blame_deadline_date"
          >
            <el-date-picker
              v-model="basicData.diff_blame_deadline_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Kelt"
            prop="completion_date"
          >
            <el-date-picker
              v-model="basicData.completion_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{
                firstDayOfWeek: 1,
                disabledDate: (date) => {
                  return date > new Date(this.basicData['start_date']);
                }
              }"
              :disabled="dialogType === 'view'"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>
<script>
  import moment from 'moment';
  export default {
    props: ['stockTakingReport', 'dialog-type', 'default'],
    data() {
      return {
        basicData: {
          storage: null,
          responsible_user: null,
          start_date: this.default['stockStartDate'],
          end_date: this.default['stockCompletedDate'],
          rate_date: '',
          close_report_deadline_date: '',
          diff_accountant_deadline_date: '',
          diff_blame_deadline_date: '',
        },
        rules: {
          year: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          number: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          start_date: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          end_date: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          rate_date: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          close_report_deadline_date: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          diff_accountant_deadline_date: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          diff_blame_deadline_date: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          completion_date: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          responsible_user: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          storage: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
        },
      }
    },
    computed: {
      users() {
        return  this.$store.getters['user/users'];
      },
      storages() {
        return this.$store.getters['storage/storages'].filter((item) => {
          return item.type === 'own';
        });
      }
    },
    watch: {
      stockTakingReport(newVal) {
        this.basicData = Object.assign({}, newVal);
      },
      default: {
        handler: function (value) {
          this.basicData['start_date'] = value['stockStartDate'];
          this.basicData['end_date'] = value['stockCompletedDate'];
          this.basicData['rate_date'] = (this.basicData['rate_date']) ? this.basicData['rate_date'] : this.addDay(this.basicData['end_date'], 5);
          this.basicData['close_report_deadline_date'] = (this.basicData['close_report_deadline_date']) ? this.basicData['close_report_deadline_date'] : this.addDay(this.basicData['rate_date'], 5);
          this.basicData['diff_accountant_deadline_date'] = (this.basicData['diff_accountant_deadline_date']) ? this.basicData['diff_accountant_deadline_date'] : this.addDay(this.basicData['close_report_deadline_date'], 5);
          this.basicData['diff_blame_deadline_date'] = (this.basicData['diff_blame_deadline_date']) ? this.basicData['diff_blame_deadline_date'] : this.addDay(this.basicData['diff_accountant_deadline_date'], 5);
        },
        deep: true
      },
    },
    methods: {
      addDay: (defaultDate, day = 0) => {
        return moment(defaultDate).add({days: day}).format('YYYY-MM-DD');
      }
    }
  }
</script>
